import * as types from './mutations-types'

export default {
   [types.SET_USU_DELEGACAO_HIST](state, payload) {
      if (payload) {
         state.items = payload.items
         state.paginaAtual = payload.paginaAtual
         state.totalDePaginas = payload.totalDePaginas
         state.registrosPorPagina = payload.registrosPorPagina
         state.totalDeRegistros = payload.totalDeRegistros
         state.possuiPaginaAnterior = payload.possuiPaginaAnterior
         state.possuiProximaPagina = payload.possuiProximaPagina
         state.codigo = payload.codigo
         state.sucesso = payload.sucesso
         state.mensagens = payload.mensagens
      } else {
         state.items = null
      }
   },
   [types.LOADING_RELATORIOS](state, loading) {
      state.loadingRelatorios = loading
   },
   [types.SET_GERAR_RELATORIO_USU_DELEGACAO](state, payload) {
      state.relatorioUsuDelegacao = payload
   }
}
